import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ddfb38a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-primary-200 z-50 safe-area-bottom"
}
const _hoisted_2 = { class: "flex justify-around items-center h-16" }
const _hoisted_3 = { class: "text-xs mt-1 font-medium" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs mt-1 font-medium" }, "More", -1))
const _hoisted_5 = {
  key: 0,
  class: "absolute bottom-full left-0 right-0 bg-white border-t border-primary-200 shadow-lg"
}
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Logout", -1))

import { computed, ref, h, FunctionalComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const showMoreMenu = ref(false);
const signedIn = computed(() => auth.loggedIn);

// SVG Icon components
const HomeIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
    }),
  ]);

const ProposalIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
    }),
  ]);

const EventIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    }),
  ]);

const ProfileIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
    }),
  ]);

const MoreIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z",
    }),
  ]);

const VoteIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
    }),
  ]);

const PaymentIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
    }),
  ]);

const GalleryIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
    }),
  ]);

const LogoutIcon: FunctionalComponent = () =>
  h("svg", { fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, [
    h("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1",
    }),
  ]);

const navItems = [
  { name: "home", label: "Home", to: "/community", icon: HomeIcon },
  {
    name: "proposals",
    label: "Proposals",
    to: "/proposals",
    icon: ProposalIcon,
  },
  { name: "events", label: "Events", to: "/events", icon: EventIcon },
  { name: "profile", label: "Profile", to: "/profile", icon: ProfileIcon },
];

const moreItems = [
  { name: "votes", label: "Votes", to: "/votes", icon: VoteIcon },
  { name: "payments", label: "Payments", to: "/payments", icon: PaymentIcon },
  { name: "gallery", label: "Gallery", to: "/gallery", icon: GalleryIcon },
];

const isActive = (to: string) => {
  return route.path === to || route.path.startsWith(to + "/");
};

const handleLogout = async () => {
  showMoreMenu.value = false;
  localStorage.clear();
  await auth.logout();
  router.push({ name: "login" });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(signedIn))
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
            return _createVNode(_component_router_link, {
              key: item.name,
              to: item.to,
              class: _normalizeClass(["flex flex-col items-center justify-center w-full h-full", isActive(item.to) ? 'text-accent-600' : 'text-primary-400']),
              "active-class": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-6 h-6" })),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          }), 64)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showMoreMenu.value = !showMoreMenu.value)),
            class: _normalizeClass(["flex flex-col items-center justify-center w-full h-full", showMoreMenu.value ? 'text-accent-600' : 'text-primary-400'])
          }, [
            _createVNode(MoreIcon, { class: "w-6 h-6" }),
            _hoisted_4
          ], 2)
        ]),
        (showMoreMenu.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(moreItems, (item) => {
                  return _createVNode(_component_router_link, {
                    key: item.name,
                    to: item.to,
                    class: "flex items-center gap-3 px-6 py-3 text-primary-700 hover:bg-primary-50 transition-colors",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showMoreMenu.value = false))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-5 h-5" })),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                }), 64)),
                _createElementVNode("button", {
                  onClick: handleLogout,
                  class: "flex items-center gap-3 px-6 py-3 w-full text-left text-red-600 hover:bg-red-50"
                }, [
                  _createVNode(LogoutIcon, { class: "w-5 h-5" }),
                  _hoisted_8
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (showMoreMenu.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "fixed inset-0 -z-10",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showMoreMenu.value = false))
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})